import type { GrafitUser } from "../domain/user/user.ts";

// To be noted ; we do not add currently account_id nor account_external_id props on the pylon chat settings;
// Account in pylon = Org in grafit, not user; So when adding these, need to be cautious of inputting the correct one,
// Otherwise the integration will fail.
declare const window: {
  pylon: {
    chat_settings: {
      app_id: string;
      email: string;
      email_hash?: string;
      name: string;
      avatar_url: string | undefined;
    };
  };
  Pylon?: (action: "show" | "hide" | "onChangeUnreadMessagesCount", callback?: (unreadCount: number) => void) => void;
};

const PYLON_APP_ID = "a07f864f-fe66-49b4-86e7-737ac58a278b";
let pylonScriptLoaded = false;

export const setChatWidget = (user: GrafitUser | null, emailHash?: string): void => {
  if (!user) {
    return;
  }

  window.pylon = {
    chat_settings: {
      app_id: PYLON_APP_ID,
      email: user.email,
      email_hash: emailHash,
      name: user.fullName,
      avatar_url: user.imageUrl,
    },
  };
};

const isAutomatedBrowser = navigator.webdriver;

export const loadPylonWidget = (): void => {
  if (pylonScriptLoaded || isAutomatedBrowser) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("async", "true");
  script.setAttribute("src", `https://widget.usepylon.com/widget/${PYLON_APP_ID}`);
  document.body.appendChild(script);
  pylonScriptLoaded = true;
};

export const openChatWidget = () => {
  if (isAutomatedBrowser) {
    return;
  }
  window.Pylon?.("show");
};

export const closeChatWidget = () => {
  if (isAutomatedBrowser) {
    return;
  }
  window.Pylon?.("hide");
};

export const onChangeUnreadMessagesCount = (callback: (unreadCount: number) => void) => {
  if (isAutomatedBrowser) {
    return;
  }
  window.Pylon?.("onChangeUnreadMessagesCount", (unreadCount) => {
    callback(unreadCount);
  });
};
